/**
 * @generated SignedSource<<feea14dc4d0673062ad173fad1c876a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bookingId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bookingId",
        "variableName": "bookingId"
      }
    ],
    "concreteType": "TicketSentType",
    "kind": "LinkedField",
    "name": "sendTicketToSms",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendTicketToSmsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendTicketToSmsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "19077edb0daab2b4c8297839f0cf42b1",
    "id": null,
    "metadata": {},
    "name": "SendTicketToSmsQuery",
    "operationKind": "query",
    "text": "query SendTicketToSmsQuery(\n  $bookingId: String!\n) {\n  sendTicketToSms(bookingId: $bookingId) {\n    message\n    status\n  }\n}\n"
  }
};
})();

node.hash = "20952ae0961f6b24e74dbf87efc691ce";

module.exports = node;
